import { env } from 'src/app/env';

const DEFAULT_TENANT_ALIAS = env.TENANT_ID;
const IS_DEVELOPMENT = env.URL_SITE?.includes('dev');
const PROGRAM_ASSETS_URL = env.PROGRAM_ASSETS;

/**
 * Generates a dynamic image URL for a instructor based on instructor ID and image type.
 *
 * @param instructor - The ID of the instructor.
 * @param tenantAlias - The tenant alias.
 * @returns The full URL of the instructor's image.
 */
export function instructorImageUrlFactory(
  instructorId: number,
  tenantAlias = DEFAULT_TENANT_ALIAS
): string {
  if (IS_DEVELOPMENT) {
    return `${PROGRAM_ASSETS_URL}/tenant/${tenantAlias}/instructors/${instructorId}/link_image.png`;
  }

  return `${PROGRAM_ASSETS_URL}/${tenantAlias}/instructors/${instructorId}/link_image.png`;
}
